import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const DEFAULT_FIELD = {table: null, column: null, value: null, operation: null, negative: false};

const INIT_FIELD = () => ({type: 'PRIMARY', ...DEFAULT_FIELD});

const INSERT_FIELD = () => ({type: 'AND', ...DEFAULT_FIELD});

export default new Vuex.Store({
  state: {
    container: [
        INIT_FIELD()
    ],
      search_data: undefined
  },
  mutations: {
    clearAll (state) {
      state.container = [
          INIT_FIELD()
      ];
    },

    add_search(state, search) {
      state.container.splice(state.container.indexOf(search) + 1, 0,
          INSERT_FIELD()
      );
    },

    delete_search(state, search) {
        state.container.splice(state.container.indexOf(search), 1)
    },
    edit_search(state, {search,
      type = search.type,
      table = search.table,
      column = search.column,
      value = search.value,
      operation = search.operation,
      negative = search.negative
    }) {
      search.type = type;
      search.table = table;
      search.column = column;
      search.value = value;
      search.operation = operation;
      search.negative = negative;
    },
      add_data_search(state, data) {
        state.search_data = data;
      },
      clear_data_search(state) {
        state.search_data = undefined;
      }
  },
  actions: {
      add_search ({commit}, search) {
          commit('add_search', search)
      },

      edit_property({commit}, {search, prop, value}) {
          let v = {search};
          v[prop] = value;
          commit('edit_search', v)
      },

      delete_search({commit}, search) {
          commit('delete_search', search)
      },
      add_data_search({commit}, data) {
          commit('add_data_search', data)
      },
      clear_data_search({commit}) {
          commit('clear_data_search')
      }

  }
})
